import { styled } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
export const GroupedListItemHead = styled('div', shouldNotForwardProps('useSalesStatistics', 'warehouseMode'))(({ theme, useSalesStatistics, warehouseMode }) => ({
    display: 'flex',
    gap: theme.spacing(8),
    paddingInline: useSalesStatistics ? theme.spacing(1) : theme.spacing(2),
    // Only needed for `<GroupedListItemTopAnchorAbsolute ref={ref} />` as CustomerDebts component
    position: 'relative',
    ...(warehouseMode && {
        paddingInline: 0,
    }),
}));
export const GroupedListItemHeadCaption = styled('h4')(({ theme }) => ({
    margin: 0,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.h4.fontSize,
    color: theme.palette.text.primary,
    lineHeight: '1.5rem',
    padding: theme.spacing(1.5, 0),
}));
